// extracted by css-extract-rspack-plugin
export default {"userRestrictedContainer":"UserRestrictedView-module__userRestrictedContainer__abcFCf8","backToAllIssuesButton":"UserRestrictedView-module__backToAllIssuesButton__CFOXV4V"};